import React from "react";
import styled from "styled-components";

export interface NumberBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number;
}

const Badge = styled.div`
  background-color: ${({ theme }) => theme.unreadIndicator.backgroundColor};
  color: ${({ theme }) => theme.unreadIndicator.fontColor};
  padding: 0 2px;
  font-size: ${({ theme }) => theme.fontSize.EXTRA_SMALL};
  font-weight: ${({ theme }) => theme.fontWeight.MEDIUM};
  line-height: 14px;
  text-align: center;
  border-radius: 2px;
  min-height: 14px;
  min-width: 12px;
`;

/**
 * Small rounded-rectangle count pill. Shares styling with the notification
 * inbox unread indicator (`theme.unreadIndicator`) — anywhere the user needs
 * a "things requiring attention" count.
 */
export const NumberBadge = React.memo(
  ({
    count,
    ref,
    ...rest
  }: NumberBadgeProps & { ref?: React.Ref<HTMLDivElement> }) => {
    return (
      <Badge ref={ref} {...rest}>
        {count < 100 ? count : `99+`}
      </Badge>
    );
  },
);
